import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import ru from 'i18n/adsimple/ru'
import en from 'i18n/adsimple/en'

i18n
  .use(initReactI18next) // bind react-i18next to the instance
  .init({
    ns: [
      'common',
      'services',
      'agency',
      'statistics',
      'referral',
      'autoreplenish',
      'oauth',
      'promised_payment',
      'auth',
      'tickets',
    ],
    fallbackLng: 'en',
    lng: global.location.pathname.split('/')[1], // get first path segment
    resources: {
      ru,
      en,
    },
    pluralSeparator: '__',
    nsSeparator: '::',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  })

export default i18n
